'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import { DeferredRequestKey } from '~/constants/common/deferredRequests';
import UserContext from '~/context/common/UserContext';
import type { FavoritesResult } from '~/server-props/common/getFavorites';

export default function FavoritesDeferred({
  promise
}: {
  promise: Promise<FavoritesResult | undefined>;
}) {
  const {
    favorites: { setData: setFavorites },
    triggerFetchFavorites
  } = useContext(UserContext);

  const onResolve = useCallback(
    (data: FavoritesResult | undefined) => {
      if (data) {
        setFavorites(data.response);
      } else {
        triggerFetchFavorites();
      }
    },
    [setFavorites, triggerFetchFavorites]
  );

  return (
    <DeferredStreamBoundary
      deferredKey={DeferredRequestKey.Favorites}
      onResolve={onResolve}
      promise={promise}
    />
  );
}
